import { render, staticRenderFns } from "./DetailReport.vue?vue&type=template&id=0f318c1b&scoped=true"
import script from "./DetailReport.vue?vue&type=script&lang=js"
export * from "./DetailReport.vue?vue&type=script&lang=js"
import style0 from "./DetailReport.vue?vue&type=style&index=0&id=0f318c1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f318c1b",
  null
  
)

export default component.exports